import styled from 'styled-components'
import { flexbox, padding } from 'styled-system'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

export const Container = styled.div.attrs({
  pt: [6, 6, 6, 15],
  pb: ['80px', '80px', '80px', '120px'],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;

  ${padding}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${BLUEPRINT_WIDTH}px;

  ${flexbox}
`
